<div class="login-page">
    <div class="login-hero" fxHide.sm="true" fxHide.xs="true">
        <img class="hero-image" src="assets/images/vineyard.png" alt="">
        <img class="logo-image" src="assets/images/logo.png" alt="Cooperativa Vinícola Garibaldi">
    </div>
    <div class="login-side">
        <div class="form">
            <img class="brand-icon" src="assets/images/icon-alt.png" alt="">
            <h1 class="title">Minha Coop</h1>
            <p class="subtitle" *ngIf="!codeSent">Informe seu CPF, CNPJ ou e-mail para receber um código de acesso.</p>
            <p class="subtitle" *ngIf="codeSent">Digite o código que enviamos para você. Ele é válido por 5 minutos.</p>

            <form *ngIf="!codeSent" [formGroup]="identifierForm" (ngSubmit)="sendCode()">
                <mat-form-field>
                    <mat-label>CPF, CNPJ ou e-mail</mat-label>
                    <input type="text" matInput formControlName="identifier" autocomplete="username">
                </mat-form-field>
                <ngx-recaptcha2 *ngIf="showCaptcha" #captchaElem class="captcha" [siteKey]="siteKey"
                    [useGlobalDomain]="false" size="normal" hl="pt" theme="light" type="image"
                    formControlName="reCaptcha">
                </ngx-recaptcha2>

                <div class="actions">
                    <button type="submit" mat-flat-button color="primary" [disabled]="loading">Receber código</button>
                    <mat-spinner *ngIf="loading" diameter="20" class="loading"></mat-spinner>
                </div>
            </form>

            <form *ngIf="codeSent" [formGroup]="codeForm" (ngSubmit)="logIn()">
                <mat-form-field>
                    <mat-label>Código</mat-label>
                    <input type="text" matInput formControlName="code" inputmode="numeric" maxlength="6"
                        autocomplete="one-time-code">
                </mat-form-field>
                <ngx-recaptcha2 *ngIf="showCaptcha" #captchaElem class="captcha" [siteKey]="siteKey"
                    [useGlobalDomain]="false" size="normal" hl="pt" theme="light" type="image"
                    formControlName="reCaptcha">
                </ngx-recaptcha2>

                <div class="actions">
                    <button type="submit" mat-flat-button color="primary" [disabled]="loading">Entrar</button>
                    <mat-spinner *ngIf="loading" diameter="20" class="loading"></mat-spinner>
                    <a mat-button color="primary" (click)="changeIdentifier()">Usar outro CPF ou e-mail</a>
                </div>
            </form>
        </div>
    </div>
</div>
